import liveStatsPollActions from './live-stats.poll.actions'
import liveStatsCountingActions from './live-stats.counting.actions'

const actions = {
  ...liveStatsPollActions,
  ...liveStatsCountingActions,
}

export default actions
